define('SC.ThreadsThemeExtension.HomeCMS', [
    'home_layout_flex.tpl',
    'Utils',
    'underscore'
], function (
    home_layout_flex,
    Utils,
    _
) {
    'use strict';
    return  {
        mountToApp: function mountToApp (application) {
            var pageType = application.getComponent('PageType');
            pageType.registerTemplate({
                pageTypes: ['home-page'],
                template: {
                    name: 'home_layout_flex.tpl',
                    displayName: 'Home Flex',
                    thumbnail: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/layout-home-flex.png')
                }
            });
        }
    };
});
